function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useMemo, useEffect } from "react";
import CloseIcon from "static/svg/close.svg";
import { getFilterIcon } from "components/pages/whats-new/utils";
import { StyledMobileFiltersComponent } from "./mobile-filters-component.scss";
import { filtersSchema } from "../../consts";
import DownArrow from "/static/svg/arrow-down.svg";
import { getCleanedFilterSchema } from "../../utils";
const MobileFiltersComponent = ({ isOpen, closeModal, setMobileFilterValues, itemsArray, setScrollToItemsList, setSelectedFilterCount })=>{
    const [filters, setFilters] = useState({});
    const [openFilters, setOpenFilters] = useState({});
    const handleMobileFiltersApply = ()=>{
        setMobileFilterValues(filters);
        setSelectedFilterCount(// Update the selectedFilterCount when filters are applied
        Object.values(filters).reduce((acc, cur)=>acc + cur.length, 0));
        setScrollToItemsList(true);
        closeModal();
    };
    const toggleFilter = (id)=>{
        setOpenFilters((prevState)=>_object_spread_props(_object_spread({}, prevState), {
                [id]: !prevState[id]
            }));
    };
    const cleanedFiltersSchema = useMemo(()=>getCleanedFilterSchema(filtersSchema, itemsArray), [
        itemsArray
    ]);
    const handleSelect = (filterId, value)=>{
        setFilters((prevState)=>{
            var _prevState_filterId;
            return _object_spread_props(_object_spread({}, prevState), {
                [filterId]: ((_prevState_filterId = prevState[filterId]) === null || _prevState_filterId === void 0 ? void 0 : _prevState_filterId.includes(value)) ? prevState[filterId].filter((v)=>v !== value) : [
                    ...prevState[filterId] || [],
                    value
                ]
            });
        });
    };
    const closeButtonClicked = ()=>{
        handleMobileFiltersApply();
        closeModal();
    };
    const clearAll = ()=>{
        setFilters({});
        setSelectedFilterCount(0);
    };
    const isFilterApplied = useMemo(()=>Object.keys(filters).some((key)=>filters[key].length > 0), [
        filters
    ]);
    useEffect(()=>{
        if (!isOpen) {
            setOpenFilters({});
        }
    }, [
        isOpen
    ]);
    if (!isOpen) return null;
    return /*#__PURE__*/ _jsx(StyledMobileFiltersComponent, {
        className: "mobile-filters-modal",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "modal-content",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "top-bar",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "top-bar-content",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "close-button",
                                    onClick: closeButtonClicked,
                                    children: /*#__PURE__*/ _jsx(CloseIcon, {})
                                }),
                                /*#__PURE__*/ _jsx("h3", {
                                    className: "filter-title",
                                    children: "Filter"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: `clear-button ${isFilterApplied ? "active" : ""}`,
                                    onClick: isFilterApplied ? clearAll : null,
                                    children: "Clear All"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "subtle-line"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "filters-section",
                    children: cleanedFiltersSchema.map((filter, index)=>{
                        var _filters_filter_id;
                        return /*#__PURE__*/ _jsxs("div", {
                            className: "filter",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: `filter-header ${((_filters_filter_id = filters[filter.id]) === null || _filters_filter_id === void 0 ? void 0 : _filters_filter_id.length) > 0 && !openFilters[filter.id] ? "has-selected" : ""}`,
                                    onClick: ()=>toggleFilter(filter.id),
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            children: filter.title
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: `down-arrow-wrapper ${openFilters[filter.id] ? "open" : ""}`,
                                            children: /*#__PURE__*/ _jsx(DownArrow, {
                                                className: "down-arrow"
                                            })
                                        })
                                    ]
                                }),
                                openFilters[filter.id] && /*#__PURE__*/ _jsx("div", {
                                    className: "filter-content",
                                    children: Object.entries(filter.data).map(([optionId, optionData])=>{
                                        var _filters_filter_id;
                                        return /*#__PURE__*/ _jsxs("div", {
                                            className: `option ${((_filters_filter_id = filters[filter.id]) === null || _filters_filter_id === void 0 ? void 0 : _filters_filter_id.includes(optionId)) ? "selected" : ""}`,
                                            onClick: ()=>handleSelect(filter.id, optionId),
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "icon",
                                                    children: getFilterIcon(optionData.name)
                                                }),
                                                optionData.name
                                            ]
                                        }, optionId);
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "subtle-line"
                                })
                            ]
                        }, filter.id);
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "bottom-bar",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "subtle-line"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: `apply-button ${isFilterApplied ? "active" : ""}`,
                            onClick: isFilterApplied ? handleMobileFiltersApply : null,
                            children: "Apply"
                        })
                    ]
                })
            ]
        })
    });
};
export default MobileFiltersComponent;
